import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import useGetUserAvatar from "@/hooks/useGetUserAvatar";
import { AccountIdentity } from "@/mappers/user/accountIdentityMapper";

type AccountAvatarProps = {
    account: AccountIdentity;
    className?: string;
};

const AccountAvatar = ({ account, className }: AccountAvatarProps) => {
    const { data: avatarUrl } = useGetUserAvatar(account.email);
    const imageSrc = account.photoURL ?? avatarUrl;

    return (
        <Avatar className={className}>
            {imageSrc && (
                <AvatarImage
                    alt={`${account.displayName}'s profile`}
                    onError={(e) => {
                        e.currentTarget.style.display = "none";
                    }}
                    src={imageSrc}
                />
            )}
            <AvatarFallback>{account.initials}</AvatarFallback>
        </Avatar>
    );
};

export default AccountAvatar;
